export default "__VITE_ASSET__fe434fc6__"